<template>
    <v-container grid-list-md class="tiktok-view-create-process">
        <v-layout row wrap>
            <v-flex md10>
                <v-form ref="form_titok_view_process">
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Nhập link video:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="linkOrId"
                                    placeholder="Nhập link video"
                                    required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!--videoRef-->
                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <span class="red_text">Lưu ý: Dịch vụ này đang thử nghiệm với người dùng thật 100% nên có thể chưa ổn định, có thể lên không đủ hoặc lên chậm, vui lòng test với số lượng nhỏ trước.</span>
                                <br>
                                <a href="#videoRef" v-if="videoId">
                                    <span class="blue_text label-highlight">Video hướng dẫn tạo job</span>
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color">Thời gian:</label>
                        </v-flex>
                        <v-flex md8 pt-6>
                            <v-select
                                    solo
                                    :items="typeSeedings"
                                    v-model="viewType"
                                    item-text="name"
                                    item-value="value"
                                    @change="initDefault"
                            ></v-select>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <span>
                                    Giá tiền 1 view = 1đ x (thời gian xem video) <br>
                                    Thời gian xem càng dài thì View càng chất lượng, vui lòng tùy chỉnh cho phù hợp với mục đích của bạn!
                                </span>
                            </div>
                        </v-flex>
                    </v-layout>

<!--                    <v-layout align-center row class="pa-0">-->
<!--                        <v-flex md4>-->
<!--                            <label class="text-color">Chế độ bảo hành: </label>-->
<!--                        </v-flex>-->
<!--                        <v-flex md8 pt-6>-->
<!--                            <v-select-->
<!--                                    solo-->
<!--                                    :items="guarantees"-->
<!--                                    v-model="guarantee"-->
<!--                                    item-text="name"-->
<!--                                    item-value="value"-->
<!--                                    @change="initDefault"-->
<!--                            >-->
<!--                            </v-select>-->
<!--                        </v-flex>-->
<!--                        <v-layout align-center row>-->
<!--                            <v-flex offset-md4>-->
<!--                                <v-card class="pa-4">-->
<!--                                    <h4>Quy định về chế độ bảo hành:</h4>-->
<!--                                    <h5 class="red&#45;&#45;text">-->
<!--                                        Thời gian bảo hành là 7 ngày tính từ ngày tạo buff!-->
<!--                                    </h5>-->
<!--                                </v-card>-->
<!--                            </v-flex>-->
<!--                        </v-layout>-->
<!--                    </v-layout>-->
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Số lượng cần tăng:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                    solo
                                    v-model="amount"
                                    type="number"
                                    :min="viewMin"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <span class="red_text">
                                    {{ noteView }}<br>
                                    {{ noteAmount2 }}
                                </span>
                            </div>
                        </v-flex>
                    </v-layout>

<!--                    <v-layout align-center row>-->

<!--                        <v-flex md4>-->
<!--                            <label class="text-color">Giá tiền mỗi tương tác:</label>-->
<!--                        </v-flex>-->
<!--                        <v-flex md8>-->
<!--                            <v-text-field-->
<!--                                    solo-->
<!--                                    v-model="price"-->
<!--                                    type="number"-->
<!--                                    :min="priceMin"-->
<!--                            ></v-text-field>-->
<!--                        </v-flex>-->
<!--                    </v-layout>-->

<!--                    <v-layout align-center row>-->
<!--                        <v-flex offset-md4>-->
<!--                            <v-card class="pa-4">-->
<!--                                <h5 class="red&#45;&#45;text">-->
<!--                                    {{ notePrice }}-->
<!--                                </h5>-->
<!--                                <h5>-->
<!--                                    (1 Coin / 1s) -->
<!--                                </h5>-->
<!--                            </v-card>-->
<!--                        </v-flex>-->
<!--                    </v-layout>-->

                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color">Ghi chú:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-textarea
                                    solo
                                    v-model="notes"
                                    placeholder="Nhập nội dung ghi chú về tiến trình của bạn"
                                    height="100px"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>

                </v-form>

                <v-layout align-center row>
                    <v-flex md12>
                        <v-card :color="COLOR.CLICK_MENU_COLOR" height="100px">
                            <v-card-title>
                                <div class="div-total">
                                    <p>
                                        Tổng: <strong>{{totalCoin | currency_init}}</strong> Coin <br>
                                        Bạn sẽ buff {{totalAmount}} với giá <strong class="green--text">{{price |
                                        currency_init}}</strong> Coin/{{unit}}
                                    </p>
                                </div>

                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout align-center row>
                    <v-flex md12>
                        <v-btn width="100%" height="50px" :color="COLOR.MAIN_COLOR" class="white--text"
                               @click="saveProcess">
                            Tạo tiến trình
                        </v-btn>
                    </v-flex>
                </v-layout>

                <!--video youtube-->
                <v-layout align-center row v-if="videoId" id="videoRef">
                    <v-flex md12>
                        <div class="col-sm-12 mb-n3">
                            <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                        </div>
                        <div class="col-sm-12 mb-n3">
                            <youtube :video-id="videoId" ref="youtube"
                                 @buffering="playing"
                                 @paused="paused"
                                 @ended="paused"
                                 @playing="playing"
                                 width="100%" height="650px">
                            </youtube>
                        </div>
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-flex md2 text_notes>
                <AttentionTiktok />
            </v-flex>
        </v-layout>
        <v-overlay :value="overlay">
            <v-progress-circular
                    indeterminate
                    color="info"
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
    import AttentionTiktok from "~/components/AttentionTiktok";
    import {COLOR, SEEDING, defaultFbPost} from "~/config/constant";
    import {validURLFb} from "../../common/helper.string";
    // import moment from 'moment';
    import Swal from 'sweetalert2';
    import {
        UVIEW_POST_GET_LIST_SEEDING,
        YOUTUBE_VIEW_SAVE_PROCESS,
        FB_POST_GET_LIST_SEEDING
    } from "~/store/actions.type";
    import $ from 'jquery';

    export default {
        name: "YoutubeViewCreateProcess",
        components: {
            AttentionTiktok
        },
        data() {
            return {
                overlay: false,
                // Color chinh
                COLOR: COLOR,
                SEEDING: SEEDING,

                // Link hoac ID ca nhan
                linkOrId: "",

                // Cac loai seeding
                listSeedingApiUView: [],
                typeSeeding: 21,
                typeSeedings: [],
                viewType: 0,
                subscribe: false,

                // Chon cam xuc
                listReaction: [],

                // Che do bao hang
                warranty: 1,
                warranties: [
                    {
                        name: "Không bảo hành (Bảo hành nếu tụt quá 70%)",
                        value: 1
                    },
                    {
                        name: "Bảo hành (Bảo hành nếu tụt quá 10%)",
                        value: 2
                    }
                ],
                // guarantees: ['Bảo hành (Bảo hành nếu tụt quá 10%)', 'Không bảo hành (Bảo hành nếu tụt quá 70%)'],
                // guarantee: 'Không bảo hành (Bảo hành nếu tụt quá 70%)',
                fromDateVal: '',
                toDateVal: '',

                // So luong can tang
                amount: defaultFbPost.YOUTUBE_VIEW.amount,
                unit: "View",
                noteAmount1: 'Mẹo nhỏ: Hệ thống ưu tiên chạy các job giá cao trước nên nếu bạn cần gấp bạn có thể set giá job của mình cao hơn 1 vài đồng để chạy nhanh nhất có thể nhé.',
                noteAmount2: 'Lưu ý: Nên buff dư thêm 30 - 50% trên tổng số lượng để tránh tụt.',
                noteView: "Số lượng cần tăng không được thấp hơn 1000",
                viewMin: 1000,
                // Gia tien
                price: 0,
                priceMin: 0,
                notePrice: "Giá thấp nhất: 0 coin",

                // Noi dung can comment
                noteComment1: "Nghiêm cấm bình luận những nội có cử chỉ, lời nói thô bạo, khiêu khích, trêu ghẹo, xúc phạm nhân phẩm, danh dự của Cá nhân hoặc Tổ chức.",
                noteComment2: "Nếu cố tình buff bạn sẽ bị trừ hết tiền và band khỏi hệ thống vĩnh viễn, và phải chịu hoàn toàn trách nhiệm trước pháp luật.",
                contentComment: '',
                contentCommentArray: [],

                // Ghi chu
                notes: "",

                // Tong so coin
                totalCoin: '',
                totalAmount: '',

                // Rules

                listSeedingApi: [],
                videoId: '',
                videoStatus: true,
            }
        },

        created() {
            this.customDataFromApi();
        },

        watch: {
            priceMin() {
                this.notePrice = "Giá thấp nhất: " + this.priceMin + " coin";
            },
            // subscribe() {
            //     this.initDefault();
            // },
            amount() {
                this.updateTotal();
                this.calculate();
            },
            price() {
                this.updateTotal();
                this.calculate();
            }
        },
        computed: {},
        mounted() {
            if ($('.menu-youtube-buff').parent().attr('aria-expanded') == "false") {
                $('.menu-youtube-buff').click();
            }
        },
        methods: {
            async customDataFromApi() {
                this.listSeedingApiUView = await this.$store.dispatch(UVIEW_POST_GET_LIST_SEEDING, {seeding_type_id: this.typeSeeding});

                this.listSeedingApiUView.shift();//15
                this.listSeedingApiUView.shift();//30

                // Set seeding
                for (let i = 0; i < this.listSeedingApiUView.length; i++) {
                    this.typeSeedings.push({
                        name: this.listSeedingApiUView[i].time + ' giây',
                        id: this.listSeedingApiUView[i].id,
                        value: i,
                        price: this.listSeedingApiUView[i].customer_per_view,
                        subscribe: this.listSeedingApiUView[i].subscribe
                        // ,
                        // guarantee: this.listSeedingApiUView[i].guarantee
                    });
                }
                this.initDefault();

                this.listSeedingApi = await this.$store.dispatch(FB_POST_GET_LIST_SEEDING);
                for (let i = 0; i < this.listSeedingApi.length; i++) {
                    if (this.listSeedingApi[i].type === 'youtube_uview') {
                        let videoId = this.youtube_parser(this.listSeedingApi[i].video[1]);
                        if (videoId) {
                            this.videoId = videoId;
                        }
                    }
                }
            },

            initDefault() {
                // seeding
                this.unit = "View";
                this.totalAmount = this.amount + ' ' + this.unit;
                this.price = (this.typeSeedings[this.viewType].price);
                this.priceMin = (this.typeSeedings[this.viewType].price);
                this.notePrice = "Giá thấp nhất: "+ this.priceMin + ' coin';

                this.calculate();
                // warranty
            },

            updateTotal() {
                this.totalAmount = this.amount + " View";
            },

            //Check post link
            validateForm() {
                let valid = true;
                // link or ID
                if (this.linkOrId.trim() === '') {
                    return {check: false, message: "Vui lòng nhập link bài post"};
                }
                if (!validURLFb(this.linkOrId, 'youtube') && !validURLFb(this.linkOrId, 'youtu.be')) {
                    return {check: false, message: "Link Post không hợp lệ"};
                }
                if (this.amount < this.viewMin) {
                    return {check: false, message: "Số lượng cần tăng phải lớn hơn " + this.viewMin};
                }

                return {check: valid, message: ""};
            },

            //Check seeding price
            validatePrice() {
                let valid = true;
                if (this.price < this.priceMin) {
                    return {checkValidatePrice: false, message: 'Giá mỗi seeding không được thấp hơn giá đề xuất'}
                }
                return {checkValidatePrice: valid, message: ''}
            },

            //Save Alert
            async saveProcess() {
                this.calculate();
                let validateForm = this.validateForm();
                let validatePrice = this.validatePrice();
                if (validateForm.check) {
                    if (!validatePrice.checkValidatePrice) {
                        Swal.fire(
                            validatePrice.message,
                            '...',
                            'error'
                        )
                    } else {
                        try {
                            Swal.fire({
                                title: 'Xác nhận',
                                text: "Bạn có chắc chắn muốn tạo tiến trình ",
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Đồng ý!',
                                cancelButtonText: 'Không'
                            }).then((result) => {
                                if (result.value) {
                                    this.overlay = true;
                                    this.saveProcessApi();
                                }
                            })
                        } catch (error) {
                            console.log(error);
                        }
                    }
                } else {
                    Swal.fire(
                        validateForm.message,
                        '...',
                        'error'
                    )
                }
            },

            //Lay thong tin nguoi dung nhap
            getParams() {
                let params = {
                    post_link: this.linkOrId,
                    seeding_type_id: 21,
                    number_seeding: this.amount,
                    total_coin: this.totalCoin,
                    note: this.notes,
                    customer_fix_coin: this.price,
                    // guarantee: this.guarantee === 'Bảo hành (Bảo hành nếu tụt quá 10%)' ? true : false,
                    guarantee: false,
                    view_type: this.typeSeedings[this.viewType].id,
                    subscribe: this.subscribe ? 1 : 0
                };
                return params;
            },

            //API Lưu thông tin
            async saveProcessApi() {
                let check = await this.$store.dispatch(YOUTUBE_VIEW_SAVE_PROCESS, this.getParams());
                if (check) {
                    this.overlay = false;
                    this.$router.go();
                } else {
                    this.overlay = false;
                }
            },
            calculate() {
                // this.totalCoin = this.amount * this.price * (1 + (this.guarantee === 'Bảo hành (Bảo hành nếu tụt quá 10%)' ? this.typeSeedings[this.viewType].guarantee / 100 : 0));
                this.totalCoin = this.amount * this.price;
            },

            playing() {
                this.videoStatus = false;
            },
            paused() {
                this.videoStatus = true;
            },
            youtube_parser(url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";

    .tiktok-view-create-process {
        background-color: $bgMainColor;
        max-width: 100% !important;

        .v-text-field__details {
            display: none;
        }

        .text-color {
            color: $mainColor;
            font-weight: bold;
        }

        .div-total {
            width: 100%;
            color: white;
            text-align: center;
        }

        .div-cx {
            height: 60px;

            .cx-img {
                cursor: pointer;

                &hover {
                    opacity: 0.8;
                }
            }

            .cxSelected {
                height: 60px;
                width: 60px;
            }
        }
    }
</style>
